import messages from '../messages'

export const PRODUCTS = [
  {
    label: messages.ANALYTICAL_CHROMATOGRAPHY,
    items: [
      {
        label: messages.ANALYTICAL_REAGENTS,
        url: '/analytical-chromatography/analytical-reagents',
      },
      {
        label: messages.ANALYTICAL_STANDARDS,
        url: '/analytical-chromatography/analytical-standards',
      },
      {
        label: messages.FOOD_ANALYSIS,
        url: '/analytical-chromatography/food-analysis',
      },
      {
        label: messages.GAS_CHROMATOGRAPHY,
        url: '/analytical-chromatography/gas-chromatography',
      },
      {
        label: messages.HPLC,
        url: '/analytical-chromatography/hplc',
      },
      {
        label: messages.SAMPLE_PREPARATION,
        url: '/analytical-chromatography/sample-preparation',
      },
      {
        label: messages.TITRATION,
        url: '/analytical-chromatography/titration',
      },
    ],
  },
  {
    label: messages.CHEMISTRY,
    items: [
      {
        label: messages.CHEMICAL_SYNTHESIS,
        url: '/chemistry/chemical-synthesis',
      },
      {
        label: messages.SOLVENTS,
        url: '/chemistry/solvents',
      },
      {
        label: messages.STABLE_ISOTOPES,
        url: '/chemistry/stable-isotopes-isotec',
      },
      {
        label: messages.STOCKROOM_REAGENTS,
        url: '/chemistry/stockroom-reagents',
      },
    ],
  },

  {
    label: messages.LIFE_SCIENCE,
    items: [
      {
        label: messages.THREE_D_CELL_CULTURE,
        url: '/life-science/3d-cell-culture',
      },
      {
        label: messages.ANTIBIOTICS,
        url: '/life-science/antibiotics',
      },
      {
        label: messages.ANTIBODIES,
        url: '/life-science/antibodies',
      },
      {
        label: messages.BIOCHEMICALS,
        url: '/life-science/biochemicals',
      },
      {
        label: messages.CELL_ANALYSIS,
        url: '/life-science/cell-analysis',
      },
      {
        label: messages.CELL_BIOLOGY,
        url: '/life-science/cell-biology',
      },
      {
        label: messages.CELL_CULTURE,
        url: '/life-science/cell-culture',
      },
      {
        label: messages.CONF_IMMUNOSSAY_PLATFORM_SOLUTIONS,
        url: '/life-science-research/protein-detection-quantification/Immunoassay-Platform-Solutions/L1Wb.qB.U80AAAFTDLgR91LE,nav',
      },
    ],
  },
  {
    label: messages.MATERIALS_SCIENCE,
    items: [
      {
        label: messages.NANOMATERIALS,
        url: '/materials-science/nanomaterials',
      },
      {
        label: messages.POLYMER_SCIENCE,
        url: '/materials-science/polymer-science',
      },
    ],
  },
  {
    label: messages.VETEC,
    items: [
      {
        label: messages.WESTERN_BLOT,
        url: '/vetec/western-blot',
      },
    ],
  },
]
